var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-3"},[_c('h4',{staticClass:"fs-30 font-weight-normal mb-0"},[_vm._v(_vm._s(_vm.item.number))]),_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.item.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }